'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.forceUpdate = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.subscribe = subscribe;

var _attributes = require('./attributes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isObserving = false; /* global window, document */

var isTicking = false;
var subscriptions = [];

function boundingBoxInViewport(boundingBox, viewPort) {
    return boundingBox.top <= viewPort.bottom && viewPort.top <= boundingBox.bottom;
}

function throttledScrollHandler() {
    isTicking = false;

    var viewPort = {
        top: 0,
        bottom: window.innerHeight
    };

    var boundingBoxes = {};
    var getBoundingBoxForId = function getBoundingBoxForId(id) {
        if (!boundingBoxes[id]) {
            var node = document.getElementById(id);
            if (!node) {
                return undefined;
            }
            boundingBoxes[id] = node.getBoundingClientRect();
        }
        return boundingBoxes[id];
    };

    subscriptions.forEach(function (subscription) {
        var id = subscription.nodeId,
            margin = subscription.margin,
            onChange = subscription.onChange,
            previousState = subscription.previousState;

        var boundingBox = getBoundingBoxForId(id);
        if (!boundingBox) {
            if (process.env.NODE_ENV !== 'production') {
                window.console.warn('Removing subscription for node "' + id + '", since it\'s not in the DOM.\n\n', 'Ensure that you do not have a content mismatch between the server rendered content ', 'and your client rendered content.');
            }
            removeSubscription(subscription);
            return;
        }

        var currentState = boundingBoxInViewport({
            top: boundingBox.top - margin,
            bottom: boundingBox.bottom + margin
        }, viewPort);

        if (previousState !== currentState) {
            subscription.previousState = currentState; // eslint-disable-line no-param-reassign
            onChange({ id: id, currentState: currentState });
        }
    });
}

function onScroll() {
    if (!isTicking) {
        isTicking = true;
        window.requestAnimationFrame(throttledScrollHandler);
    }
}

function removeSubscription(subscription) {
    var index = subscriptions.indexOf(subscription);
    if (index >= 0) {
        subscriptions = [].concat((0, _toConsumableArray3.default)(subscriptions.slice(0, index)), (0, _toConsumableArray3.default)(subscriptions.slice(index + 1)));
    }
    if (subscriptions.length === 0) {
        window.removeEventListener('scroll', onScroll);
        isObserving = false;
    }
}

var forceUpdate = exports.forceUpdate = onScroll;
function subscribe(node, options) {
    // eslint-disable-line import/prefer-default-export
    var subscription = (0, _extends3.default)({}, options, {
        nodeId: (0, _attributes.getId)(node)
    });
    subscriptions.push(subscription);

    if (!isObserving) {
        isObserving = true;
        window.addEventListener('scroll', onScroll);
    }
    forceUpdate();

    return {
        unsubscribe: function unsubscribe() {
            return removeSubscription(subscription);
        }
    };
}
//# sourceMappingURL=observer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/observer.js
 ** module id = 264
 ** module chunks = 1
 **/